import { Container } from 'react-bootstrap';

const SiteLaunchMessage = () => (
    <p className='mb-0 p-2 small text-black'>
        <span className='me-2 badge rounded-pill text-white bg-info'>
            <span className='visually-hidden'>This portal is a </span>
            Beta
            <span className='visually-hidden'> release.</span>
        </span>
        {' This is a new NMI Services portal - your '}
        <a
            // Site launch survey link
            href='https://industry.au1.qualtrics.com/jfe/form/SV_9X41DIbsi8FvCQu'
            rel='external'
            target='NMI-Feedback'
            className='small text-black'
        >
            feedback
            <span className='visually-hidden'> Opens in a new tab</span>
        </a>
        {' will help us to improve it.'}
    </p>
);

const SiteMaintenanceMessage = () => (
    <p className='mb-0 p-2 small text-black'>
        <span className='me-2 badge rounded-pill text-white bg-dark-red'>Site Maintenance</span>
        {' This site will be under maintenance from dd MMM YYYY until dd MMM YYYY.'}
    </p>
);

const NavbarMessage = () => (
    <Container fluid className='-bg-dark-gray -bg-light-blue bg-light-blue-tint'>
        <Container>
            <SiteLaunchMessage />
        </Container>
    </Container>
);

export default NavbarMessage;
